import React,{useState,useRef} from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import '../divida.css';
import { useHistory } from "react-router-dom";
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import { te } from 'date-fns/locale';
import { TextEditor } from "text-editor-react";
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Button, Space,Select ,} from 'antd';
import { Input } from 'antd';
import { set } from 'date-fns';

toast.configure()
function Gateway() {
    const [casa,setCasa]=useState(null);
    const [error,setError]=useState(null);
    const { TextArea } = Input;
    const history = useHistory();
    const [text,setText]=useState(null);
    const [Editor_texto,setEditorT]=useState('dfdfdf');
    const id = "my-unique-id";
    const [cliente,setTodosClientes]=useState(null);
    const [zona,setZona]=useState(null);
    const [ind,setInd]=useState(null);
    const [val,setValor]=useState(null);
    const [tipo,setTipo]=useState(null);

    const handleChange = (value: string) => {
   
       if (value==='individual') {
        setTipo('individual');
        console.log('df')
        setInd('dd');
        setZona(null);
        setTodosClientes(null);

       }
       
       else if (value=="Zona"){
        setTipo('Zona');
        setZona(true);
        setInd(null);
        setTodosClientes(null);
       }
       
       else {
        setTipo('Geral');
        setTodosClientes(value);
        setValor(value);
        setInd(null);
        setZona(null);
        
       }
   

      };

    const handleChangebb=(value: string)=>{
        setValor(value);

    }
    const Escrever=()=>{
       
        axios(
            axios({
                method:"post",
                url:`${localStorage.getItem('url')}/web/EnviarMensagem/`,
                headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
                data:{texto:text,valor_envio:val,tipo_envio:tipo}
            }).then(dat=>{ if(dat.status!==200){
                throw Error('Dados de acesso invalidos');  
                    }
                return dat
             } ).then( d=>{
                
              toast.success("Enviado Com sucesso!")
              
               
             }
           
               ).catch(e=>{
                toast.error("Sem sucesso!")
                setError(e.message );
            })

        )
    }
  return (
    <div>
         {Editor_texto && <>
          {/*<Editor  onChange={(e)=>setCasa(e)}
                />*/}  
        <Space direction="vertical"   style={{ width: '100%' }}   >Tipo de Envio<Select
      defaultValue="selecionar"
      style={{ width: 120 }}
      onChange={handleChange}
      options={[
    
        { value: 'Coletivo', label: 'coletivo' },
        { value: 'Zona', label: 'zona' },
        { value: 'individual', label: 'Individual' },
      ]}
    />
        <Space>
            Destinatario:  {cliente && <Input value={'Todos Clientes'}      readOnly={true}  />}  
            {ind  &&  <Input placeholder='8X XXX XXXX'    onChange={(e)=>setValor(e.target.value)}   />}
            { zona &&   <Select
      defaultValue="selecionar zona"
      style={{ width: 120 }}
      onChange={handleChangebb}
      options={[
    
        { value: 'Aeroporto', label: 'Aeroporto' },
        { value: 'junho', label: '25 de Junho' },
        { value: 'coop PH5', label: 'Coop PH5' },
        { value: 'coop PH6', label: 'Coop PH6' },
        { value: 'Munhuana', label: 'Munhuana' },
      ]}
    />}
        </Space>


       <TextArea rows={4} onChange={(e)=>setText(e.target.value)} />
          
          <Space >
         
            <Button type="primary" onClick={Escrever}>Enviar</Button>
          
       </Space>
    
    
    </Space>
         

         </>
         }
          
    </div>

    )
}

export default Gateway;